import { useTranslation } from '@frontend/i18n';
import { Text } from '@frontend/design-system';
import { merchantStatusStyles } from '../styles';

type StatusTextProps = {
  label: string;
  status: boolean;
  trackingId: string;
  count?: number;
};
export const StatusText = ({ label, status, trackingId, count }: StatusTextProps) => {
  const { t } = useTranslation('payments', { keyPrefix: 'settings' });
  return (
    <div css={merchantStatusStyles.accountInfo}>
      <Text color='light' size='medium'>
        {label}
      </Text>
      <Text
        weight='bold'
        color={status ? 'success' : 'error'}
        data-trackingid={`pay-portal-settings-label-${trackingId}`}
      >
        {!!count && count + ' '}
        {status ? t('Active') : t('Inactive')}
      </Text>
    </div>
  );
};
